export const KeyValuePairModel = function (data) {
    if (!data) data = {};
    this.key = data.key || null;
    this.value = data.value || null;
  };